(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function setupSourceitFooter(){
  document.querySelectorAll('.sif').forEach(footer=>{
    if(footer.dataset.ready)return;
    footer.dataset.ready='true';
    const media=window.matchMedia('(min-width:750px)');
    const update=()=>footer.querySelectorAll('.sif-links').forEach(details=>{
      details.open=media.matches;
      details.querySelector('summary').tabIndex=media.matches?-1:0;
    });
    update();
    media.addEventListener('change',update);
  });
}
setupSourceitFooter();
document.addEventListener('shopify:section:load',setupSourceitFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-article-ausom"]) return;
  try {
    
function initAusomArticle(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const content = root.querySelector('.sia-content');
  const nav = root.querySelector('.sia-toc');
  const list = nav.querySelector('ol');
  content.querySelectorAll('h2').forEach((heading, index) => {
    if (!heading.id) heading.id = content.id + '-part-' + index;
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent;
    li.append(a);
    list.append(li);
  });
  nav.hidden = !list.children.length;
}
document.querySelectorAll('[data-si-article]').forEach(initAusomArticle);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-si-article]').forEach(initAusomArticle));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-article-pall"]) return;
  try {
    
function initPallArticle(root){if(root.dataset.ready)return;root.dataset.ready='true';const content=root.querySelector('.sia-content'),nav=root.querySelector('.sia-toc'),list=nav.querySelector('ol');content.querySelectorAll('h2').forEach((h,i)=>{h.id=h.id||content.id+'-'+i;const li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.append(a);list.append(li)});nav.hidden=!list.children.length;const success=root.querySelector('.sp-success');if(success)success.focus()}
document.querySelectorAll('[data-pall-article]').forEach(initPallArticle);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pall-article]').forEach(initPallArticle));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-charger-finder"] && !Shopify.designMode) return;
  try {
    
/* Shared photo and delivery module. No secret is shipped to the browser. */
window.SourceitEnquiry = (() => {
  const API='https://31.70.158.66/enquiries-api/';
  const locale=(document.documentElement.lang||'fr').split('-')[0];
  let messages={};
  try{messages=JSON.parse(document.querySelector('[data-sourceit-enquiry-i18n]')?.textContent||'{}')}catch{}
  const t=(fr,english)=>messages[fr]??(locale==='fr'?fr:english);
  const translatedError=message=>messages[message]||t('Envoi non confirmé.','Delivery not confirmed.');
  const labels={connecteur:t('Connecteur','Connector'),batterie:t('Étiquette de batterie','Battery label'),chargeur:t('Ancien chargeur','Existing charger'),autre:t('Autre photo','Other photo')};
  const hex=n=>Array.from(crypto.getRandomValues(new Uint8Array(n)),x=>x.toString(16).padStart(2,'0')).join('');
  function mount(host){
    const files=[];const urls=new Set();
    const existing=host.querySelector('[data-static-photos]');const box=existing||document.createElement('section');box.className='si-photo-upload';
    const grouped=host.dataset.photoLayout==='categories';
    const title=document.createElement('h3');title.textContent=grouped?t('Photos pour identifier votre chargeur','Photos to identify your charger'):t('Ajouter des photos (facultatif)','Add photos (optional)');if(!existing)box.append(title);
    const help=document.createElement('p');help.textContent=t('Connecteur, étiquette de batterie ou ancien chargeur. 4 photos maximum, 10 Mo par photo et 40 Mo au total. JPEG, PNG ou WebP, 20 mégapixels maximum.','Connector, battery label or existing charger. Up to 4 photos, 10 MB each and 40 MB total. JPEG, PNG or WebP, up to 20 megapixels.');if(!existing)box.append(help);
    const select=document.createElement('select');select.setAttribute('aria-label',t('Sujet des photos','Photo subject'));for(const [value,label] of Object.entries(labels)){const o=document.createElement('option');o.value=value;o.textContent=label;select.append(o)}
    const input=document.createElement('input');input.type='file';input.multiple=true;input.accept='image/jpeg,image/png,image/webp';input.setAttribute('aria-label',t('Choisir des photos','Choose photos'));
    if(!grouped){box.append(select,input)}
    const error=document.createElement('p');error.setAttribute('role','alert');box.append(error);
    const previews=document.createElement('div');previews.className='si-photo-previews';box.append(previews);host.append(box);
    function draw(){previews.replaceChildren();files.forEach((item,i)=>{const card=document.createElement('div');const img=document.createElement('img');img.src=item.url;img.alt=labels[item.category];img.width=100;img.height=80;const caption=document.createElement('span');caption.textContent=labels[item.category]+' — '+item.file.name;const remove=document.createElement('button');remove.type='button';remove.textContent=t('Supprimer','Remove');remove.onclick=()=>{URL.revokeObjectURL(item.url);urls.delete(item.url);files.splice(i,1);draw()};card.append(img,caption,remove);previews.append(card)})}
    function addFiles(control,category){error.textContent='';for(const file of control.files){if(!['image/jpeg','image/png','image/webp'].includes(file.type)){error.textContent=t('Format refusé. Exportez la photo en JPEG, PNG ou WebP, 20 mégapixels maximum.','Unsupported format. Export as JPEG, PNG or WebP, up to 20 megapixels.');continue}if(files.length>=4||file.size>10*1024*1024||files.reduce((n,x)=>n+x.file.size,0)+file.size>40*1024*1024){error.textContent=t('Limite atteinte : 4 photos, 10 Mo chacune, 40 Mo au total.','Limit reached: 4 photos, 10 MB each, 40 MB total.');continue}const url=URL.createObjectURL(file);urls.add(url);files.push({file,category,url})}control.value='';draw()}
    input.onchange=()=>addFiles(input,select.value);
    if(grouped&&!existing){
      const choices=[
        ['connecteur',t('Connecteur de charge — facultatif','Charging connector — optional'),t('Photographiez la prise du véhicule bien de face, avec les broches visibles.','Take a front-facing photo of the vehicle charging socket, with the pins visible.')],
        ['batterie',t('Étiquette de la batterie — facultatif','Battery label — optional'),t('Si elle est accessible, ajoutez une photo lisible des caractéristiques.','If accessible, add a readable photo of the specifications.')],
        ['chargeur',t('Ancien chargeur — facultatif','Existing charger — optional'),t('Si vous l’avez encore, photographiez son étiquette et sa prise.','If you still have it, photograph its label and connector.')]
      ];
      const groups=document.createElement('div');groups.className='si-photo-groups';
      for(const [category,caption,hint] of choices){
        const group=document.createElement('div');group.className='si-photo-group';
        const heading=document.createElement('strong');heading.textContent=caption;
        const note=document.createElement('p');note.textContent=hint;
        const picker=input.cloneNode();picker.setAttribute('aria-label',t('Importer des photos : ','Upload photos: ')+caption);picker.onchange=()=>addFiles(picker,category);
        group.append(heading,note,picker);groups.append(group);
      }
      box.insertBefore(groups,error);
    }
    if(existing){existing.querySelectorAll('input[data-photo-category]').forEach(picker=>{picker.onchange=()=>addFiles(picker,picker.dataset.photoCategory);if(picker.files.length)addFiles(picker,picker.dataset.photoCategory)});}
    window.addEventListener('pagehide',()=>urls.forEach(url=>URL.revokeObjectURL(url)),{once:true});
    return {async photos(){return Promise.all(files.map(item=>new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve({category:item.category,data:String(reader.result).split(',')[1]});reader.onerror=reject;reader.readAsDataURL(item.file)})))},clear(){files.length=0;urls.forEach(x=>URL.revokeObjectURL(x));urls.clear();draw()}};
  }
  function bind(form,{source,getData,photoHost,statusHost,submitButton}){
    const uploader=mount(photoHost||form);let attempt=null,busy=false;
    const status=document.createElement('p');status.className='si-enquiry-status';status.setAttribute('role','status');(statusHost||form).append(status);
    const trap=document.createElement('input');trap.name='website';trap.tabIndex=-1;trap.autocomplete='off';trap.setAttribute('aria-hidden','true');trap.style.cssText='position:absolute;left:-10000px;width:1px;height:1px';form.append(trap);
    const privacy=document.createElement('p');privacy.className='si-enquiry-privacy';privacy.textContent=t('Vos réponses, coordonnées et photos seront transmises à Source’IT pour traiter votre demande. Les photos sont analysées puis jointes à notre e-mail ; les copies de traitement sont supprimées du serveur.','Your answers, contact details and photos will be sent to Source’IT to handle your enquiry. Photos are scanned and attached to our email; processing copies are removed from the server.');(statusHost||form).append(privacy);
    const original=submitButton.textContent;
    async function request(url,options={}){
      const controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),120000);
      try{return await fetch(url,{...options,signal:controller.signal})}
      finally{clearTimeout(timer)}
    }

    const sleep=ms=>new Promise(r=>setTimeout(r,ms));
    async function poll(receipt){for(let n=0;n<120;n++){let response;
      try{response=await request(API+'status/'+receipt.id,{headers:{Authorization:'Bearer '+receipt.token},credentials:'omit',cache:'no-store'});}
      catch(error){status.textContent=t('Connexion interrompue, vérification de l’envoi en cours…','Connection interrupted, checking submission…');await sleep(5000);continue;}
      if(response.status===429||response.status>=500){await sleep(5000);continue;}
if(!response.ok)throw Error(t('Impossible de vérifier l’état. Conservez cette référence : ','Unable to check status. Keep this reference: ')+receipt.id);const result=await response.json();if(result.status==='sent'){status.textContent=t('Demande envoyée avec vos photos. Référence : ','Enquiry sent with your photos. Reference: ')+receipt.id;uploader.clear();submitButton.textContent=t('Demande envoyée','Enquiry sent');return true}if(['failed','rejected','uncertain'].includes(result.status)){status.textContent=((result.error?translatedError(result.error):'')||t('Envoi non confirmé.','Delivery not confirmed.'))+' '+t('Référence : ','Reference: ')+receipt.id;if(result.status!=='uncertain')attempt=null;return false}status.textContent=t('Photos en cours de contrôle, puis envoi de la demande…','Checking photos, then sending your enquiry…');await sleep(5000)}status.textContent=t('Le traitement continue. Cliquez pour vérifier l’état ; aucune nouvelle demande ne sera créée. Référence : ','Processing continues. Click to check status; no new enquiry will be created. Reference: ')+receipt.id;return false}
    form.addEventListener('submit',async event=>{if(event.defaultPrevented)return;event.preventDefault();if(busy||!form.reportValidity())return;busy=true;submitButton.disabled=true;try{if(!attempt){const health=await request(API+'health',{credentials:'omit',cache:'no-store'});if(!health.ok||!(await health.json()).ready)throw Error(t('Envoi temporairement indisponible. Contactez contact@source-it.fr.','Sending temporarily unavailable. Contact contact@source-it.fr.'));const data=getData();attempt={id:hex(12),token:hex(32),body:{...data,source,website:trap.value,photos:await uploader.photos()}}}status.textContent=t('Transmission de votre demande…','Uploading your enquiry…');const response=await request(API+'requests',{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({...attempt.body,requestId:attempt.id,requestToken:attempt.token})});const result=await response.json();if(!response.ok){attempt=null;throw Error((result.error?translatedError(result.error):'')||t('Envoi refusé.','Request rejected.'))}const sent=await poll(result);if(sent)return;}catch(e){status.textContent=(e instanceof TypeError||e.name==='AbortError')?t('Connexion interrompue. Cliquez sur reprendre pour vérifier le même envoi.','Connection interrupted. Resume to check the same submission.'):e.message||t('Connexion interrompue. Réessayez pour vérifier le même envoi.','Connection interrupted. Retry to check the same submission.')}finally{busy=false;if(submitButton.textContent!==t('Demande envoyée','Enquiry sent')){submitButton.disabled=false;submitButton.textContent=attempt?t('Vérifier / reprendre l’envoi','Check / resume submission'):original}}});
    return uploader;
  }
  return {mount,bind};
})();

function attachSourceitPhotos(root) {
  const form=root.querySelector('form');
  if(!form||form.dataset.photosReady||!window.SourceitEnquiry)return;
  const send=root.querySelector('[data-send]');
  if(!send)return;
  const host=root.querySelector('[data-photo-upload]');
  const statusHost=root.querySelector('[data-enquiry-status]');
  SourceitEnquiry.bind(form,{source:'standard',photoHost:host,statusHost,submitButton:send,getData:()=>{
    const fields={};const fd=new FormData(form);
    for(const [key,value] of fd){if(key.startsWith('contact[')&&typeof value==='string')fields[key.slice(8,-1)]=value;}
    const contact={name:fields.name||'',email:fields.email||'',phone:fields.phone||''};
    delete fields.name;delete fields.email;delete fields.phone;
    return {contact,fields};
  }});
  form.dataset.photosReady='true';
  send.disabled=false;
}
function initSourceitPhotoForms(){document.querySelectorAll('.sicf').forEach(attachSourceitPhotos)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSourceitPhotoForms);else initSourceitPhotoForms();
document.addEventListener('shopify:section:load',initSourceitPhotoForms);


function initSourceitFinder(root){if(root.dataset.ready)return;root.dataset.ready='true';const form=root.querySelector('form');const steps=[...root.querySelectorAll('[data-step]')];if(!steps.length)return;const next=root.querySelector('[data-next]'),back=root.querySelector('[data-back]'),send=root.querySelector('[data-send]'),progress=root.querySelector('.sicf-progress');let index=0;root.classList.add('js-ready');progress.hidden=false;root.querySelector('progress').max=steps.length;form.noValidate=true;
function summary(){const box=root.querySelector('[data-summary]');box.replaceChildren();for(const [name,value]of new FormData(form)){if(!name.startsWith('contact[')||!value)continue;const field=form.elements.namedItem(name);if(field?.type==='hidden')continue;const first=field instanceof RadioNodeList?field[0]:field;const label=first?.labels?.[0];const caption=first?.type==='radio'?first.closest('fieldset')?.querySelector('legend')?.textContent:label?.textContent;const p=document.createElement('p'),b=document.createElement('strong');b.textContent=(caption||name.slice(8,-1)).trim()+' : ';p.append(b,document.createTextNode(value));box.append(p)}}
function show(focus){steps.forEach((s,i)=>s.hidden=i!==index);back.hidden=index===0;next.hidden=index===steps.length-1;send.hidden=index!==steps.length-1;root.querySelector('progress').value=index+1;root.querySelector('[data-step-text]').textContent=root.dataset.stepLabel.replace('[current]',index+1).replace('[total]',steps.length);if(index===steps.length-1)summary();if(focus){const target=steps[index].querySelector('legend');target.tabIndex=-1;target.focus({preventScroll:true});requestAnimationFrame(()=>{let offset=16;document.querySelectorAll('.shopify-section-header-sticky,sticky-header').forEach(header=>{const r=header.getBoundingClientRect();if(r.top<=1&&r.bottom>0)offset=Math.max(offset,r.bottom+16)});window.scrollTo({top:Math.max(0,window.scrollY+progress.getBoundingClientRect().top-offset),behavior:'instant'})})}}
function validStep(step){const invalid=[...step.querySelectorAll('input,textarea,select')].find(x=>!x.checkValidity());if(invalid){invalid.reportValidity();return false}return true}
next.addEventListener('click',()=>{if(validStep(steps[index])){index++;show(true)}});back.addEventListener('click',()=>{index--;show(true)});form.addEventListener('submit',e=>{if(index<steps.length-1){e.preventDefault();next.click();return}const bad=steps.findIndex(s=>!validStepNoReport(s));if(bad>=0){e.preventDefault();index=bad;show(true);validStep(steps[index])}});function validStepNoReport(s){return [...s.querySelectorAll('input,textarea,select')].every(x=>x.checkValidity())}show(false)}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('.sicf').forEach(initSourceitFinder),{once:true})}else{document.querySelectorAll('.sicf').forEach(initSourceitFinder)}document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.sicf').forEach(initSourceitFinder));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-home-draft"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
 const button=event.target.closest('[data-brand-direction]');
 if(!button)return;
 const rail=button.closest('.sih-universe-row').querySelector('.sih-brand-rail');
 if(rail)rail.scrollBy({left:Number(button.dataset.brandDirection)*(getComputedStyle(rail).direction==="rtl"?-1:1)*rail.clientWidth*.8,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});


  } catch(e) { console.error(e); }
})();
})();
